var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 15,
    viewBox: "0 0 33 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_813_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 6.0625H12.4531V4.45312C12.4531 1.7219 10.2312 -0.5 7.5 -0.5C4.76878 -0.5 2.54688 1.7219 2.54688 4.45312V6.0625H2.34375C1.29124 6.0625 0.4375 6.91624 0.4375 7.96875V13.5938C0.4375 14.6463 1.29124 15.5 2.34375 15.5H12.6562C13.7088 15.5 14.5625 14.6463 14.5625 13.5938V7.96875C14.5625 6.91624 13.7088 6.0625 12.6562 6.0625ZM5.89062 6.0625V4.45312C5.89062 3.56618 6.61306 2.84375 7.5 2.84375C8.38694 2.84375 9.10938 3.56618 9.10938 4.45312V6.0625H5.89062Z",
    fill: "black",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_813_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6562 6.0625H21.4531V4.45312C21.4531 1.7219 19.2312 -0.5 16.5 -0.5C13.7688 -0.5 11.5469 1.7219 11.5469 4.45312V6.0625H11.3438C10.2912 6.0625 9.4375 6.91624 9.4375 7.96875V13.5938C9.4375 14.6463 10.2912 15.5 11.3438 15.5H21.6562C22.7088 15.5 23.5625 14.6463 23.5625 13.5938V7.96875C23.5625 6.91624 22.7088 6.0625 21.6562 6.0625ZM14.8906 6.0625V4.45312C14.8906 3.56618 15.6131 2.84375 16.5 2.84375C17.3869 2.84375 18.1094 3.56618 18.1094 4.45312V6.0625H14.8906Z",
    fill: "black",
    stroke: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_813_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6562 6.0625H30.4531V4.45312C30.4531 1.7219 28.2312 -0.5 25.5 -0.5C22.7688 -0.5 20.5469 1.7219 20.5469 4.45312V6.0625H20.3438C19.2912 6.0625 18.4375 6.91624 18.4375 7.96875V13.5938C18.4375 14.6463 19.2912 15.5 20.3438 15.5H30.6562C31.7088 15.5 32.5625 14.6463 32.5625 13.5938V7.96875C32.5625 6.91624 31.7088 6.0625 30.6562 6.0625ZM23.8906 6.0625V4.45312C23.8906 3.56618 24.6131 2.84375 25.5 2.84375C26.3869 2.84375 27.1094 3.56618 27.1094 4.45312V6.0625H23.8906Z",
    fill: "black",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_813_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_813_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_813_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockAll);
export default __webpack_public_path__ + "static/media/lockAll.1b29248b4658fe5becdb3346556e6e75.svg";
export { ForwardRef as ReactComponent };